import API from './axios';

export interface AboutUs {
  _id: string;
  name: string;
  description: {
    en: string;
    ru: string;
  };
  techStack: {
    backend: {
      title: {
        en: string;
        ru: string;
      };
      technologies: string[];
    };
    frontend: {
      title: {
        en: string;
        ru: string;
      };
      technologies: string[];
    };
    mobile: {
      title: {
        en: string;
        ru: string;
      };
      technologies: string[];
    };
  };
  additionalExpertiseInfo: {
    en: string;
    ru: string;
  };
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateAboutUsDto {
  name?: string;
  description?: {
    en: string;
    ru: string;
  };
  techStack?: {
    backend: {
      title: {
        en: string;
        ru: string;
      };
      technologies: string[];
    };
    frontend: {
      title: {
        en: string;
        ru: string;
      };
      technologies: string[];
    };
    mobile: {
      title: {
        en: string;
        ru: string;
      };
      technologies: string[];
    };
  };
  additionalExpertiseInfo?: {
    en: string;
    ru: string;
  };
  isActive?: boolean;
}

export const aboutUsApi = {
  // Get all about us
  getAll: async (): Promise<AboutUs[]> => {
    const response = await API.get('/about-us');
    return response.data;
  },

  // Get main about us
  getMain: async (): Promise<AboutUs> => {
    const response = await API.get('/about-us/main');
    return response.data;
  },

  // Get about us by ID
  getById: async (id: string): Promise<AboutUs> => {
    const response = await API.get(`/about-us/${id}`);
    return response.data;
  },

  // Update main about us
  updateMain: async (data: UpdateAboutUsDto): Promise<AboutUs> => {
    const response = await API.patch('/about-us/main', data);
    return response.data;
  },

  // Update about us by ID
  update: async (id: string, data: UpdateAboutUsDto): Promise<AboutUs> => {
    const response = await API.patch(`/about-us/${id}`, data);
    return response.data;
  },

  // Create new about us
  create: async (data: Partial<AboutUs>): Promise<AboutUs> => {
    const response = await API.post('/about-us', data);
    return response.data;
  },

  // Delete about us
  delete: async (id: string): Promise<void> => {
    await API.delete(`/about-us/${id}`);
  },

  // Initialize main about us
  initialize: async (): Promise<AboutUs> => {
    const response = await API.post('/about-us/initialize');
    return response.data;
  },
};